import { useEventListener, useIntervalFn } from "@vueuse/core";
import { useRouter } from "vue-router";
import { useAuthStore } from "../stores/authStore";

export function setupCheckAuth() {
  const router = useRouter();
  const authStore = useAuthStore();

  const checkAuth = () => {
    if (authStore.isAuthenticated && authStore.mfaState.isMFACompleted) {
      router.push("/");
    }
  };

  checkAuth();

  useEventListener(window, "storage", (event: StorageEvent) => {
    if (event.key === "authState") {
      checkAuth();
    }
  });

  useEventListener(document, "visibilitychange", () => {
    if (document.visibilityState === "visible") {
      checkAuth();
    }
  });

  useIntervalFn(() => {
    checkAuth();
  }, 3000);
}
